import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../../global/global.service';
import { ResponseBackExt, ResponseBackExtAndIdCalculo } from '../generico/generico.model';
import { IPerfilCalculadoIn, IPerfilCuestionario, IPerfilCalculadoOut, IPerfilInversion, IPerfilGrabarIn, IPerfilGrabarOut, IPerfilListPerfiles } from './perfilamiento.model';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PerfilamientoService {
  // https://rgw.desa.kepler.sura.net.pe/sura-fondos-desa-web-fondos/proyecto-web-fondos/api/fondos/fondos-consultas-service/perfil/cuestionarios/123456
  // http://localhost:8081/api/fondos-consultas-service/perfil/cuestionarios
  private url = `${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/perfil/`;
  //https://4bfootxoo9.execute-api.us-west-2.amazonaws.com/test/api/fondos
  //https://svomamozu5.execute-api.us-west-2.amazonaws.com/dev/api/fondos/cliente/private/perfil/calculoperfil/historico-perfil/perfil-vigente/PE/DNI00030982
  constructor(private http: HttpClient, private globalService: GlobalService) { }

  getConsultarPerfil(cuc: string | null,  pais: string = "PE") {
    /*if (respPrueba)
      return of<ResponseBackExt<IPerfilInversion>>(this.perfilActualizado);
    else
      return of<ResponseBackExt<IPerfilInversion>>(this.perfilPorVencer);
    */
       return this.http.get<ResponseBackExt<IPerfilInversion>>(`${this.url}calculoperfil/historico-perfil/perfil-vigente/${pais}/${cuc}`);
  }

  getCuestionario(pais: string) {
    //return of<ResponseBackExt<IPerfilCuestionario[]>>(responseCuestionario);
    //https://svomamozu5.execute-api.us-west-2.amazonaws.com/dev/api/fondos/cliente/private/perfil/calculoperfil/formulario/PE
    return this.http.get<ResponseBackExt<IPerfilCuestionario>>(`${this.url}calculoperfil/formulario/${pais}`);
  }

  //https://svomamozu5.execute-api.us-west-2.amazonaws.com/dev/api/fondos/cliente/private/perfil/calculoperfil/perfil/PE
  getDescripcionPerfil(pais: string) {
    //return of<ResponseBackExt<IPerfilListPerfiles[]>>(mockPerfiles);
     return this.http.get<ResponseBackExt<IPerfilListPerfiles>>(`${this.url}calculoperfil/perfil/${pais}`);
  }

//https://svomamozu5.execute-api.us-west-2.amazonaws.com/dev/api/fondos/cliente/private/perfil/calculoperfil
  getCalcularPerfil(dataOut: IPerfilCalculadoOut) {
    //return of<ResponseBackExtAndIdCalculo<IPerfilCalculadoIn>>(mockPerfilCalculado);
     return this.http.post<ResponseBackExt<IPerfilCalculadoIn>>(`${this.url}calculoperfil`, dataOut);
  }
//https://svomamozu5.execute-api.us-west-2.amazonaws.com/dev/api/fondos/cliente/private/perfil/calculoperfil/historico-perfil
  grabarPerfil(dataOut: IPerfilGrabarOut) {
    //return of<ResponseBackExt<IPerfilGrabarIn>>(mockGrabarPerfil);
     return this.http.post<ResponseBackExt<IPerfilCalculadoIn>>(`${this.url}calculoperfil/historico-perfil`, dataOut);
  }
  ///api/fondos/cliente/private/perfil/enviarcorreoperfilamiento

  enviarCorreoEmail(nombres: string, cuc: string, perfilInversionista: string) {
    //return of<ResponseBackExt<IPerfilListPerfiles[]>>(mockPerfiles);
     return this.http.get<any>(`${this.url}enviarcorreoperfilamiento?nombres=${nombres}&cuc=${cuc}&perfilInversionista=${perfilInversionista}`);
  }

  perfilActualizado: ResponseBackExt<IPerfilInversion> = { response: true, data: { ...mockPerfil, porvencer: false } };
  perfilPorVencer: ResponseBackExt<IPerfilInversion> = { response: true, data: { ...mockPerfil, porvencer: true } };
}

const mockGrabarPerfil = {
  "response": true,
  "data": {
    "idcalculo": "25A1D293-CA87-4A39-A496-01F7E8C5EEB1",
    "idpais": "PE",
    "idcliente": "111111111111",
    "nombre": "JUAN",
    "apellido": "MALETIN",
    "idcanal": "WF_PE",
    "idperfil_calculado": "MODERADO",
    "idperfil_aceptado": "CONSERVADOR",
    "generadorpor": "CLIENTE",
    "id": "1845F65C-D4ED-4E39-97D7-9F9BAC044AE1",
    "fechacreacion": new Date("2024-08-22T21:15:12.470Z"),
    "fechamodificacion": new Date("2024-08-22T21:15:12.470Z")
  }
}

const mockPerfilCalculado = {
  "response": true,
  "data": {
    "id": "6AB1D55E-15F2-4500-B103-214511AD1980",
    "idperfil": "CONSERVADOR",
    "nombre": "Conservador",
    "codigo": "CONSERVADOR",
    "fechacreacion": new Date(),
    "fechamodificacion": new Date(),
    "rangoCalculodesde": 18,
    "rangoCalculohasta": 37,
    "idpais": "PE",
    "explicacion": "Es susceptible de frustración al enfrentar perdidas o volatilidad en el mercado, por lo que prefiere optar por inversiones que ofrezcan alta probabilidad o certeza en los retornos aun cuando esto signifique rendimientos menores.\n\nPrivilegian la preservación o el crecimiento lento, por lo que elije inversiones de bajo riesgo con una rentabilidad moderada pero estable al no tolerar fluctuaciones significativas del capital.",
    "pordefecto": "S",
  },
  "idcalculo": "25A1D293-CA87-4A39-A496-01F7E8C5EEB1",
}

const mockPerfil: IPerfilInversion = {
  "id": "2552CB39-996D-4453-936B-C2E52E7AA6C3",
  "idpais": "PE",
  "idcliente": "111111111111",
  "idcanal": "SALFORCE",
  "generadorpor": "CLIENTE",
  "nombreasesor": null,
  "emailasesor": null,
  "fechacreacion": new Date("2024-08-16T17:21:24.847Z"),
  "fechamodificacion": new Date("2024-08-16T17:21:24.847Z"),
  "canal": {
    "id": "45D5EA0D-CCC5-439A-A3CA-385611EF1D73",
    "idcanal": "SALFORCE",
    "descripcion": "Salforce",
    "prioridad": 1,
    "fechacreacion": "2024-05-29T18:06:34.957Z",
    "fechamodificacion": "2024-05-29T18:06:34.957Z"
  },
  "historicocalculoperfilcalculo": {
    "id": "ADD5C569-3798-4CFA-89F5-E5F6C4DB1F0C",
    "idpais": "PE",
    "idformulario": "PE-FORM-2024",
    "idcliente": "111111111111",
    "edad": 41,
    "idperfil": "CONSERVADOR",
    "fechacreacion": new Date("2024-08-19T19:13:51.517Z"),
    "fechamodificacion": new Date("2024-08-19T19:13:51.517Z")
  },
  "porvencer": false,
  "idperfil_calculado": "MODERADO",
  "idperfil_aceptado": "CONSERVADOR"
}

const mockPerfiles = {
  "response": true,
  "data": [
    {
      "id": "15C2E5ED-0F10-4265-A9DC-E4C0A0733921",
      "idperfil": "AGRESIVO",
      "nombre": "Dinamico/Agresivo",
      "codigo": "AGRESIVO",
      "fechacreacion": new Date("2024-05-29T17:38:40.820Z"),
      "fechamodificacion": new Date("2024-05-29T17:38:40.820Z"),
      "rangoCalculodesde": 53,
      "rangoCalculohasta": 61,
      "idpais": "PE",
      "explicacion": "Se considera audaz o arriesgado a la hora de invertir, por lo que comprende las diferentes tendencias del mercado, sin asustarse en momentos de alta volatilidad.\nEs capaz de asumir mayor riesgo si quiere obtener mayores ganancias, siendo muy intuitivo y confiado en su conocimiento y experiencia, por lo que se siente cómodo tomando decisiones arriesgadas."
    },
    {
      "id": "6AB1D55E-15F2-4500-B103-214511AD1980",
      "idperfil": "CONSERVADOR",
      "nombre": "Conservador",
      "codigo": "CONSERVADOR",
      "fechacreacion": new Date("2024-05-29T17:38:40.820Z"),
      "fechamodificacion": new Date("2024-05-29T17:38:40.820Z"),
      "rangoCalculodesde": 18,
      "rangoCalculohasta": 37,
      "idpais": "PE",
      "explicacion": "Es susceptible de frustración al enfrentar perdidas o volatilidad en el mercado, por lo que prefiere optar por inversiones que ofrezcan alta probabilidad o certeza en los retornos aun cuando esto signifique rendimientos menores.\nPrivilegian la preservación o el crecimiento lento, por lo que elije inversiones de bajo riesgo con una rentabilidad moderada pero estable al no tolerar fluctuaciones significativas del capital."
    },
    {
      "id": "9EA42EDC-5B27-40A0-9C93-B863A8AD65BE",
      "idperfil": "MODERADO",
      "nombre": "Moderado",
      "codigo": "MODERADO",
      "fechacreacion": new Date("2024-05-29T17:38:40.820Z"),
      "fechamodificacion": new Date("2024-05-29T17:38:40.820Z"),
      "rangoCalculodesde": 38,
      "rangoCalculohasta": 52,
      "idpais": "PE",
      "explicacion": "Toma decisiones arriesgadas cuando tiene un buen nivel de certeza, pero cuando hay pesimismo o incertidumbre en el mercado prefiere moderarse.\nRequiere que exista un equilibrio entre riesgo y seguridad, por lo que elije inversiones de riesgo medio con mayores retornos asumiendo ciertas fluctuaciones en el corto plazo."
    }
  ],
  "rows": 3
}

const responseCuestionario = {
  "response": true,
  "data": [
    {
      "id": "B1859B1C-EEF7-49B9-8099-26A0B7433570",
      "idformulario": "PE-FORM-2024",
      "idtipopregunta": 1,
      "descripcion": "escenario inversion",
      "pregunta": "Imagina que tienes la oportunidad de invertir 100,000 USD en una de las siguientes alternativas de inversión, cada una con distintos escenarios igualmente probables. ¿Cuál elegirías?",
      "orden": 1,
      "fechacreacion": "2024-06-10T16:54:46.080Z",
      "fechamodificacion": "2024-06-10T16:54:46.080Z",
      "explicacion": "Es esencial evaluar cómo se comporta un inversionista ante posibles pérdidas o ganancias. Optar por menos riesgo puede resultar en rendimientos menores que los de estrategias más arriesgadas, pero ofrece mayor estabilidad en el valor de la inversión, lo que da tranquilidad en tiempos de volatilidad del mercado.\n\nSi tu respuesta muestra disposición a enfrentar escenarios de mayores pérdidas o ganancias, te consideramos una persona cómoda con los altibajos del mercado y dispuesta a asumir riesgos significativos en busca de rendimientos mayores. Por otro lado, algunos inversionistas prefieren mantener una cartera equilibrada que ofrezca estabilidad y menor volatilidad, lo cual les brinda más tranquilidad.",
      "multiseleccion": "N",
      "tiporespuestapregunta": [
        {
          "id": "95839EA4-48BD-499A-AEEB-7427EBAB1DE0",
          "idformulario": "PE-FORM-2024",
          "idtipopregunta": 1,
          "idtiporespuestapregunta": "A",
          "descripcion": "Escenario 1: Posible ganacia 5% o posible perdida -3%",
          "orden": 1,
          "factorpuntaje": 3,
          "fechacreacion": "2024-06-10T16:54:46.080Z",
          "fechamodificacion": "2024-06-10T16:54:46.080Z"
        },
        {
          "id": "AB86CB92-DD97-4C44-8DBB-65BFC31C1328",
          "idformulario": "PE-FORM-2024",
          "idtipopregunta": 1,
          "idtiporespuestapregunta": "B",
          "descripcion": "Escenario 2: Posible ganacia 10% o posible perdida -7%",
          "orden": 2,
          "factorpuntaje": 6,
          "fechacreacion": "2024-06-10T16:54:46.080Z",
          "fechamodificacion": "2024-06-10T16:54:46.080Z"
        },
        {
          "id": "633C4782-DA7E-4DE1-B83C-F6435BD34833",
          "idformulario": "PE-FORM-2024",
          "idtipopregunta": 1,
          "idtiporespuestapregunta": "C",
          "descripcion": "Escenario 3: Posible ganacia 20% o posible perdida -10%",
          "orden": 3,
          "factorpuntaje": 9,
          "fechacreacion": "2024-06-10T16:54:46.080Z",
          "fechamodificacion": "2024-06-10T16:54:46.080Z"
        }
      ]
    },
    {
      "id": "6FA61F69-2445-4A7A-A28B-FD1B06F2854C",
      "idformulario": "PE-FORM-2024",
      "idtipopregunta": 2,
      "descripcion": "desvalorizacion",
      "pregunta": "Suponiendo que tu inversión sufre una alta desvalorización en el último mes. ¿Qué harías? ",
      "orden": 2,
      "fechacreacion": "2024-06-10T16:54:46.080Z",
      "fechamodificacion": "2024-06-10T16:54:46.080Z",
      "explicacion": "La volatilidad del mercado puede generar incertidumbre y miedo debido a las drásticas fluctuaciones en el valor de las inversiones. Asumir más riesgos puede ofrecer mayores rendimientos, pero también conlleva el riesgo de pérdidas sustanciales. Por otro lado, una estrategia excesivamente conservadora podría limitar el crecimiento necesario para alcanzar sus objetivos financieros.\n\nSi tiendes a vender sus inversiones durante períodos de volatilidad en el mercado, esto indica una baja tolerancia al riesgo, sugiriendo que podrías preferir una cartera más conservadora. Por el contrario, si mantienes o aumentas tus inversiones en estos momentos, muestra una alta tolerancia al riesgo y podrías estar cómodo con una asignación más agresiva de activos.",
      "multiseleccion": "S",
      "tiporespuestapregunta": [
        {
          "id": "64F1CC2A-14E6-487F-8FDF-E51514B10A96",
          "idformulario": "PE-FORM-2024",
          "idtipopregunta": 2,
          "idtiporespuestapregunta": "A",
          "descripcion": "Retiraría el total de mi inversión, no quisiera arriesgar nada.",
          "orden": 1,
          "factorpuntaje": 2,
          "fechacreacion": "2024-06-10T16:54:46.080Z",
          "fechamodificacion": "2024-06-10T16:54:46.080Z"
        },
        {
          "id": "D62B4503-9008-46FC-8ABC-2EBCD206982C",
          "idformulario": "PE-FORM-2024",
          "idtipopregunta": 2,
          "idtiporespuestapregunta": "B",
          "descripcion": "Retiraría una parte de mi inversión, no quisiera arriesgarlo todo.",
          "orden": 2,
          "factorpuntaje": 4,
          "fechacreacion": "2024-06-10T16:54:46.080Z",
          "fechamodificacion": "2024-06-10T16:54:46.080Z"
        },
        {
          "id": "2521854D-A74D-4A58-B523-59A821CE3F46",
          "idformulario": "PE-FORM-2024",
          "idtipopregunta": 2,
          "idtiporespuestapregunta": "C",
          "descripcion": "Mantendría mi inversión, confío en que podría recuperarse.",
          "orden": 3,
          "factorpuntaje": 6,
          "fechacreacion": "2024-06-10T16:54:46.080Z",
          "fechamodificacion": "2024-06-10T16:54:46.080Z"
        },
        {
          "id": "4C46FEC8-9418-4873-8487-6AD49A8227CB",
          "idformulario": "PE-FORM-2024",
          "idtipopregunta": 2,
          "idtiporespuestapregunta": "D",
          "descripcion": "Incrementaría mi inversión, me arriesgaría es un buen momento para comprar.",
          "orden": 4,
          "factorpuntaje": 6,
          "fechacreacion": "2024-06-10T16:54:46.080Z",
          "fechamodificacion": "2024-06-10T16:54:46.080Z"
        }
      ]
    },
    // {
    //     "id": "D6405A93-BFAC-4E5C-A28E-3EF99C6415B3",
    //     "idformulario": "PE-FORM-2024",
    //     "idtipopregunta": 3,
    //     "descripcion": "instrumentos",
    //     "pregunta": "De los siguientes instrumentos financieros, ¿en cuáles invierte o ha invertido?",
    //     "orden": 3,
    //     "fechacreacion": "2024-06-10T16:54:46.080Z",
    //     "fechamodificacion": "2024-06-10T16:54:46.080Z",
    //     "explicacion": "Es necesario comprender cuál es nivel de conocimiento en inversiones de los clientes para adaptar las recomendaciones y el acompañamiento a sus necesidades, nivel sofisticación y entendimiento de los productos. Esto permite ofrecer desde asesoramiento básico hasta orientaciones más complejas y sofisticadas, en función de su conocimiento y experiencias vividas en el pasado con activos financieros.\n\nEl inversionista debe seleccionar los productos que conoce o en los que haya invertido. Cada producto tiene una caracterización que nos permite saber si su nivel de conocimiento es alto, medio o bajo. El conocimiento financiero quedará determinado por la calificación del producto seleccionado que tenga la calificación más alta.",
    //     "multiseleccion": "S",
    //     "tiporespuestapregunta": [
    //         {
    //             "id": "16567D77-7746-4D99-8A14-AD0C9225E734",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 3,
    //             "idtiporespuestapregunta": "A",
    //             "descripcion": "Nunca he invertido en instrumentos Financieros.",
    //             "orden": 1,
    //             "factorpuntaje": 1,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "A5CFCBB4-34DD-458B-947C-68C3F5241522",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 3,
    //             "idtiporespuestapregunta": "B",
    //             "descripcion": "Depósitos a plazos. ",
    //             "orden": 2,
    //             "factorpuntaje": 1,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "BB09CDCB-0050-466B-8ADD-E92D4CAE8558",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 3,
    //             "idtiporespuestapregunta": "C",
    //             "descripcion": "Fondos Mutuos de Renta Fija.",
    //             "orden": 3,
    //             "factorpuntaje": 2,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "AFBAA283-5990-4082-B01E-FB792095A3B8",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 3,
    //             "idtiporespuestapregunta": "D",
    //             "descripcion": "Fondos Mutuos de Renta Variable.",
    //             "orden": 4,
    //             "factorpuntaje": 3,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "ECF1B03F-B1D1-4257-B788-66296D5023EE",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 3,
    //             "idtiporespuestapregunta": "E",
    //             "descripcion": "Activos Alternativos o Derivados.",
    //             "orden": 5,
    //             "factorpuntaje": 4,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         }
    //     ]
    // },
    // {
    //     "id": "669ECEFE-D612-4950-8F73-2AB010EECE6C",
    //     "idformulario": "PE-FORM-2024",
    //     "idtipopregunta": 4,
    //     "descripcion": "conocimiento",
    //     "pregunta": "¿Cómo describiría su conocimiento como inversionista?",
    //     "orden": 4,
    //     "fechacreacion": "2024-06-10T16:54:46.080Z",
    //     "fechamodificacion": "2024-06-10T16:54:46.080Z",
    //     "explicacion": "Es necesario comprender cuál es nivel de conocimiento en inversiones de los clientes para adaptar las recomendaciones y el acompañamiento a sus necesidades, nivel sofisticación y entendimiento de los productos. Esto permite ofrecer desde asesoramiento básico hasta orientaciones más complejas y sofisticadas, en función de su conocimiento y experiencias vividas en el pasado con activos financieros.",
    //     "multiseleccion": "N",
    //     "tiporespuestapregunta": [
    //         {
    //             "id": "5D72BD2E-3244-448A-A532-6AE54938E318",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 4,
    //             "idtiporespuestapregunta": "A",
    //             "descripcion": "Alto, estoy muy familiarizado con el mundo financiero y entiendo conceptos avanzados de inversión. ",
    //             "orden": 1,
    //             "factorpuntaje": 1,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "26303A5C-5651-46B6-80E0-6888EA294224",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 4,
    //             "idtiporespuestapregunta": "B",
    //             "descripcion": "Medio, estoy familiarizado con el mundo financiero y entiendo algunos conceptos de inversión. ",
    //             "orden": 2,
    //             "factorpuntaje": 2,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "51099421-93CB-4A52-9B6E-F6BB1E6B0768",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 4,
    //             "idtiporespuestapregunta": "C",
    //             "descripcion": "Bajo, no estoy tan familiarizado con el mundo financiero y los conceptos de inversión. ",
    //             "orden": 3,
    //             "factorpuntaje": 3,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         }
    //     ]
    // },
    // {
    //     "id": "3DD73711-4583-4BFC-9DD1-7E553D300AD5",
    //     "idformulario": "PE-FORM-2024",
    //     "idtipopregunta": 5,
    //     "descripcion": "tiempo retiro",
    //     "pregunta": "¿Dentro de cuánto tiempo piensa hacer uso de esta inversión?",
    //     "orden": 5,
    //     "fechacreacion": "2024-06-10T16:54:46.080Z",
    //     "fechamodificacion": "2024-06-10T16:54:46.080Z",
    //     "explicacion": "La duración de la estrategia de inversión puede variar de corto a largo plazo, dependiendo de sus objetivos, como la compra de una casa, financiar la educación universitaria o asegurar una jubilación prolongada. Es importante considerar estos objetivos futuros al planificar su estrategia de inversión.\n\nCalcula la cantidad de tiempo que tienes hasta que necesites comenzar a gastar el dinero que estás invirtiendo. Si tu plazo es corto, requiere de una asignación más conservadora para preservar sus activos. Si no necesitarás el dinero durante muchos años, se sugiere una asignación que le brindará a tus activos el potencial de crecer con el tiempo.",
    //     "multiseleccion": "N",
    //     "tiporespuestapregunta": [
    //         {
    //             "id": "00BC79E8-47DE-4DC1-B087-43328E64140C",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 5,
    //             "idtiporespuestapregunta": "A",
    //             "descripcion": "Menos de un año",
    //             "orden": 1,
    //             "factorpuntaje": 3,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "A55AC0FA-7EAF-4F6C-8723-D2FFE52D2AE3",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 5,
    //             "idtiporespuestapregunta": "B",
    //             "descripcion": "Entre 1 y 3 años",
    //             "orden": 2,
    //             "factorpuntaje": 6,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "CABBF6E2-031D-4342-825D-1E7BE44CBA8D",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 5,
    //             "idtiporespuestapregunta": "C",
    //             "descripcion": "Entre 3 y 5 años",
    //             "orden": 3,
    //             "factorpuntaje": 9,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "234C6B27-E924-498F-840F-FB45B24ADD5B",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 5,
    //             "idtiporespuestapregunta": "D",
    //             "descripcion": "Más de 5 años.  ",
    //             "orden": 4,
    //             "factorpuntaje": 12,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         }
    //     ]
    // },
    // {
    //     "id": "3871C548-BE5B-41E2-AF01-6AB75C756449",
    //     "idformulario": "PE-FORM-2024",
    //     "idtipopregunta": 6,
    //     "descripcion": "perdida capital",
    //     "pregunta": "¿En caso de que pierda parte de mi capital invertido, considero que?",
    //     "orden": 6,
    //     "fechacreacion": "2024-06-10T16:54:46.080Z",
    //     "fechamodificacion": "2024-06-10T16:54:46.080Z",
    //     "explicacion": "Es crucial entender cuánto riesgo puede asumir un inversionista sin comprometer su capacidad para financiar futuros compromisos financieros y mantener su calidad de vida.\n\nSu capacidad financiera como inversionista, representada por su riqueza neta, determina el respaldo económico disponible y el nivel de riesgo financiero que puede manejar.",
    //     "multiseleccion": "N",
    //     "tiporespuestapregunta": [
    //         {
    //             "id": "A2BCFF0D-B414-42F9-91FE-DA3BCACCB1BC",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 6,
    //             "idtiporespuestapregunta": "A",
    //             "descripcion": "Tengo una situación financiera sólida, no modificaría mi plan de inversión.",
    //             "orden": 1,
    //             "factorpuntaje": 12,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "D69B0924-D3AC-491A-9605-17E76863D272",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 6,
    //             "idtiporespuestapregunta": "B",
    //             "descripcion": "Mi situación financiera es estable, solo ante imprevistos mayores modificaría mi plan de inversión.",
    //             "orden": 2,
    //             "factorpuntaje": 8,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "DB47E0E8-EB57-447C-8B1C-717FFA219029",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 6,
    //             "idtiporespuestapregunta": "C",
    //             "descripcion": "Cualquier imprevisto puede impactar mi situación financiera y debería modificar mi plan de inversión.",
    //             "orden": 3,
    //             "factorpuntaje": 4,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         }
    //     ]
    // },
    // {
    //     "id": "AC96E8E3-E95A-4168-97E9-838A47E02101",
    //     "idformulario": "PE-FORM-2024",
    //     "idtipopregunta": 7,
    //     "descripcion": "origen de los recursos",
    //     "pregunta": "¿Cuál es el principal origen de los recursos que está destinando a inversiones?",
    //     "orden": 7,
    //     "fechacreacion": "2024-06-10T16:54:46.080Z",
    //     "fechamodificacion": "2024-06-10T16:54:46.080Z",
    //     "explicacion": "La composición de su cartera de activos puede variar entre conservadora y agresiva, dependiendo de sus ingresos actuales y futuros. Una situación financiera estable ofrece una base firme para fundamentar su estrategia de inversión.\n\nUna mayor estabilidad te brinda más oportunidades de asumir riesgos de inversión. Una menor estabilidad sugiere que un enfoque más conservador podría servir mejor a sus intereses a largo plazo.",
    //     "multiseleccion": "S",
    //     "tiporespuestapregunta": [
    //         {
    //             "id": "693E8B26-3A2F-4883-92E6-11A56D1C8197",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 7,
    //             "idtiporespuestapregunta": "A",
    //             "descripcion": "Pensión o Ahorro Plan de Jubilación.",
    //             "orden": 1,
    //             "factorpuntaje": 1,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "E9C7E08C-CD55-4296-9C91-4A73427C48C8",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 7,
    //             "idtiporespuestapregunta": "B",
    //             "descripcion": "Sueldo, Salarios o Ingresos por negocios o comisiones.",
    //             "orden": 2,
    //             "factorpuntaje": 1,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "B07C36E0-A4D8-4385-BD5E-8841064A9ECD",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 7,
    //             "idtiporespuestapregunta": "C",
    //             "descripcion": "Ahorros acumulados.",
    //             "orden": 3,
    //             "factorpuntaje": 2,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "31224DC6-2083-4214-9F04-98B6D815996E",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 7,
    //             "idtiporespuestapregunta": "D",
    //             "descripcion": "Herencia, Fideicomisos.",
    //             "orden": 4,
    //             "factorpuntaje": 3,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "864F5038-C776-4082-A644-2CC6CCA34440",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 7,
    //             "idtiporespuestapregunta": "E",
    //             "descripcion": "Venta de Activos o Negocios propios.",
    //             "orden": 5,
    //             "factorpuntaje": 3,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         }
    //     ]
    // },
    // {
    //     "id": "75B36BC5-B0D3-4002-ADBB-7291FC34577D",
    //     "idformulario": "PE-FORM-2024",
    //     "idtipopregunta": 8,
    //     "descripcion": "porcentaje reparto",
    //     "pregunta": "¿Qué parte del total de tu patrimonio destinas a inversiones?",
    //     "orden": 8,
    //     "fechacreacion": "2024-06-10T16:54:46.080Z",
    //     "fechamodificacion": "2024-06-10T16:54:46.080Z",
    //     "explicacion": "La composición de su cartera de activos puede variar entre conservadora y agresiva, dependiendo de sus ingresos actuales y futuros. Una situación financiera estable ofrece una base firme para fundamentar su estrategia de inversión.\n\nUna mayor estabilidad te brinda más oportunidades de asumir riesgos de inversión. Una menor estabilidad sugiere que un enfoque más conservador podría servir mejor a sus intereses a largo plazo.",
    //     "multiseleccion": "N",
    //     "tiporespuestapregunta": [
    //         {
    //             "id": "B17D623E-1D4F-42DF-8ECB-F368A2E68990",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 8,
    //             "idtiporespuestapregunta": "A",
    //             "descripcion": "Elevado (más del 75%).",
    //             "orden": 1,
    //             "factorpuntaje": 2,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "A6E46AD9-8067-4792-9394-C4249FE17878",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 8,
    //             "idtiporespuestapregunta": "B",
    //             "descripcion": "Notable (entre 50% y 75%).",
    //             "orden": 2,
    //             "factorpuntaje": 4,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "68A38AEF-E2BE-481A-8BEC-C80AB6F465E7",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 8,
    //             "idtiporespuestapregunta": "C",
    //             "descripcion": "Medio (entre 25% y 50%).",
    //             "orden": 3,
    //             "factorpuntaje": 6,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         },
    //         {
    //             "id": "F86E90B9-17BA-4F9A-8754-3D2AE5D0A0F5",
    //             "idformulario": "PE-FORM-2024",
    //             "idtipopregunta": 8,
    //             "idtiporespuestapregunta": "D",
    //             "descripcion": "Bajo (menos del 25%).",
    //             "orden": 4,
    //             "factorpuntaje": 8,
    //             "fechacreacion": "2024-06-10T16:54:46.080Z",
    //             "fechamodificacion": "2024-06-10T16:54:46.080Z"
    //         }
    //     ]
    // }
  ]
}
